import { z } from "zod";
export const AddressSchema = z.object({
    line1: z.string(),
    line2: z.string().optional().nullable(),
    city: z.string(),
    state: z.string(),
    postal_code: z.string(),
    country: z.string(),
});
export const BillingAddressSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("personal"),
        name: z.string(),
        address: AddressSchema,
        phone: z.string().optional(),
    }),
    z.object({
        type: z.literal("business"),
        name: z.string(),
        address: AddressSchema,
        phone: z.string().optional(),
        taxId: z.string().optional(),
        taxIdType: z.string().optional(),
        externalTaxIdType: z.string().optional(),
    }),
]);
//# sourceMappingURL=schemas.js.map